import { render, staticRenderFns } from "./StockView.vue?vue&type=template&id=6672ef62"
import script from "./StockView.vue?vue&type=script&lang=js"
export * from "./StockView.vue?vue&type=script&lang=js"
import style0 from "./StockView.vue?vue&type=style&index=0&id=6672ef62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports